import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const employeeAssetsConstants = {
    EMPLOYEE_ASSETS_DEVICE_LOADED: 'EMPLOYEE_ASSETS_DEVICE_LOADED',
    EMPLOYEE_ASSETS_MOBILE_DEVICE_LOADED: 'EMPLOYEE_ASSETS_MOBILE_DEVICE_LOADED',
    EMPLOYEE_ASSETS_RESERVATION_LOADED: 'EMPLOYEE_ASSETS_RESERVATION_LOADED',
    EMPLOYEE_ASSETS_TRANSITION_LOADED: 'EMPLOYEE_ASSETS_TRANSITION_LOADED',
    EMPLOYEE_ASSETS_LICENSE_LOADED: 'EMPLOYEE_ASSETS_LICENSE_LOADED',
};

export const employeeAssetsFulfilledConstants = getActionTypesResult(employeeAssetsConstants, '_FULFILLED');
export const employeeAssetsPendingConstants = getActionTypesResult(employeeAssetsConstants, '_PENDING');
export const employeeAssetsRejectedConstants = getActionTypesResult(employeeAssetsConstants, '_REJECTED');

export const fetchEmployeeAssetsDevice =
    createAsyncAction(employeeAssetsConstants.EMPLOYEE_ASSETS_DEVICE_LOADED, query =>
        api.get('user/equipment/devices', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchEmployeeAssetsMobileDevice =
    createAsyncAction(employeeAssetsConstants.EMPLOYEE_ASSETS_MOBILE_DEVICE_LOADED, query =>
        api.get('user/equipment/mobileDevices', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchEmployeeAssetsReservedDevice =
    createAsyncAction(employeeAssetsConstants.EMPLOYEE_ASSETS_RESERVATION_LOADED, query =>
        api.get('user/equipment/devices/reserved', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchEmployeeAssetsTransitedDevice =
    createAsyncAction(employeeAssetsConstants.EMPLOYEE_ASSETS_TRANSITION_LOADED, query =>
        api.get('user/equipment/devices/transited', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchEmployeeAssetsLicense =
    createAsyncAction(employeeAssetsConstants.EMPLOYEE_ASSETS_LICENSE_LOADED, query =>
        api.get('user/equipment/licenses', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
